import { useQuery, gql } from '@apollo/client';
import { useSelector } from 'react-redux';

export function useReportDailyResponseHumidityLog() {
  const {
    environment: {
      weather: {
        historicDailyLog: { year, week, day, dataPoint },
      },
    },
  } = useSelector(({ state }) => state);
  const { data = { reportDailyResponseHumidityLog: [] }, loading } = useQuery(GET_OVERVIEW, {
    variables: { year, week, day, dataPoint },
    skip: skip({ year, week, day, dataPoint }),
  });
  let dataOverview = [];
  data.reportDailyResponseHumidityLog.forEach((rows) => {
    dataOverview.push(rows);
  });
  return { loading, data: dataOverview || [] };
}

function skip(variables) {
  let skip = true;
  let { year, week, day, dataPoint } = variables;
  skip = ![year, week, day, dataPoint].every((v) => v);
  return skip;
}

const GET_OVERVIEW = gql`
  query ReportDailyResponseHumidityLog($year: Int!, $week: Int!, $day: Int!, $dataPoint: String!) {
    reportDailyResponseHumidityLog: ReportDailyResponseHumidityLog(
      year: $year
      week: $week
      day: $day
      dataPoint: $dataPoint
    ) {
      _id
      text
      color
      data {
        _id
        hour
        value
      }
    }
  }
`;
